<template>
  <div class="top-item" v-if="data.length">
    <img
      class="item-title-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9d860c405d317383976d6388e55e6533.webp"
      alt=""
    />
    <div class="item-padding">
      <div class="toggle-open" @click="bindToggleOpen">
        <span class="toggle-open-text" v-show="!isOpen">获取更多积分</span
        ><span
          class="iconfont icon-black"
          :class="{ 'open-roate': isOpen }"
        ></span>
      </div>
      <div
        class="task-container"
        id="task-container"
        :class="{ 'task-container-limit': !isOpen }"
      >
        <div class="task-info" v-if="taskInfo.count"
          >今日还有
          <span class="red">{{ taskInfo.count }}</span> 个任务未完成，还可领取
          <span class="red">{{ taskInfo.num }}</span> 积分
        </div>
        <div class="task-tag-list">
          <div class="task-tag-item" v-for="(item, index) in data" :key="index">
            <div class="task-tag-title">
              <div class="line"></div>
              <div class="title">{{ item.plan_type_name }}</div>
              <div class="line"></div>
            </div>
            <div class="task-list">
              <div
                class="task-item"
                v-for="(item1, index1) in item.list"
                :key="index1"
              >
                <img :src="item1.icon" class="item-icon" alt="" />
                <div class="item-center">
                  <div
                    ><span class="item-title">{{ item1.name }}</span
                    ><img
                      class="item-num-icon"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/526935ebb62d34ed1258b8047048ec3c.webp"
                      alt=""
                    /><span class="item-num">{{ item1.reward_num }}</span></div
                  >
                  <div class="item-desc">{{ item1.notice }}</div>
                </div>
                <div
                  class="item-btn"
                  :class="{ 'item-btn-confirm': item1.isComplete }"
                  @click="bindClickItem(item1)"
                  >{{ item1.isComplete ? '已完成' : item1.button_content }}</div
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    taskInfo() {
      let count = 0
      let num = 0
      if (this.data) {
        this.data.map((item) => {
          item.list.map((item1) => {
            if (!item1.isComplete) {
              count++
              num += item1.reward_num
            }
          })
        })
      }
      return {
        count,
        num
      }
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    bindToggleOpen() {
      this.isOpen = !this.isOpen
    },
    bindClickItem(item) {
      if (item.isComplete) {
        return
      }
      /* 新人问卷任务单独处理 */
      if (item.plan_id == 1 && item.que_state == 1) {
        this.getQuetion(item)
        return
      }
      if (item.complete_type == 1) {
        this.$emit('confirm', item)
      }
      this.$betterwe.jumpRoute(item.jump_url)
    },
    /* 获取新人问卷 */
    getQuetion(item) {
      this.$http
        .getBaseApp('/member/AppCamp/receiveComerQue', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$betterwe.jumpRoute(item.jump_url)
          } else {
            this.$toast(res.msg)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.top-item {
  .item-title-image {
    width: 100%;
  }

  .item-padding {
    position: relative;
    overflow: hidden;
    padding: 0px 16px 30px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.03);
    border-radius: 0px 0px 16px 16px;

    .toggle-open {
      transition: transform 0.3s ease;
      position: absolute;
      left: 50%;
      bottom: 10px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, 0%) rotate(0deg);
      color: rgba(0, 0, 0, 0.3);
      font-size: 20px;
      transform-origin: center center;
      .toggle-open-text {
        font-size: 12px;
        white-space: nowrap;
      }
    }
    .open-roate {
      transform: translate(-50%, 0%) rotate(180deg);
    }
  }

  .task-container {
    overflow: hidden;
    padding-top: 2px;

    .task-info {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 18px;
      margin-bottom: 26px;

      .red {
        color: #ff4444;
      }
    }

    .task-tag-list {
      .task-tag-item {
        margin-bottom: 30px;

        .task-tag-title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(139, 55, 22, 0.5);
          line-height: 12px;
          margin-bottom: 26px;

          .title {
            margin: 0 12px;
          }

          .line {
            width: 78px;
            height: 1px;
            background-color: rgba(139, 55, 22, 0.16);
          }
        }

        .task-list {
          .task-item {
            display: flex;
            align-items: center;
            margin-bottom: 26px;

            .item-icon {
              width: 44px;
              height: 44px;
              object-fit: contain;
              margin-right: 10px;
            }

            .item-center {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              margin-right: 10px;
            }

            .item-title {
              font-size: 15px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 24px;
              margin-right: 5px;
            }

            .item-num-icon {
              display: inline-block;
              width: 11px;
              height: 11px;
              object-fit: contain;
              margin-right: 3px;
            }

            .item-num {
              font-size: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ff6464;
              line-height: 22px;
            }

            .item-desc {
              font-size: 11px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 18px;
            }

            .item-btn {
              width: 66px;
              height: 28px;
              background: linear-gradient(270deg, #ff4078 0%, #ff634c 100%);
              border-radius: 15px;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ffffff;
              line-height: 28px;
              text-align: center;
            }

            .item-btn-confirm {
              background: rgba(255, 66, 66, 0.09);
              color: #ff4444;
            }
          }

          .task-item:last-child {
            margin-bottom: 0;
          }
        }
      }

      .task-tag-item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .task-container-limit {
    max-height: 617px;
  }
}
</style>
